/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { AddFittingPopupComponent } from "../../components/add-fitting-popup/add-fitting-popup.component";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class AddFittingsDialog implements PopupDialog {

    create(sysquePopupConfig: SysquePopupConfig): any {
        sysquePopupConfig.component = AddFittingPopupComponent;
        sysquePopupConfig.data = null;
        sysquePopupConfig.visible = true;
        sysquePopupConfig.width = 1227;
        sysquePopupConfig.height = 850;
        sysquePopupConfig.componentTitle = "Add Fittings";
    }

}